import templateUrl from './event-host-detail.component.html';

/**
 * A presentational component that displays details about an event host.
 */
export const EventHostDetailComponent = {
    templateUrl,
    bindings: {
        eventHost: "<"
    }
}
